<slotcom-loading> </slotcom-loading>
@if (hasError()) {
  <slotcom-button
    class="c-button--pink retry-button"
    (click)="retry()">
    {{ 'home.buttons.retry' | translate | uppercase }}
  </slotcom-button>
}
@if (retriesExhausted()) {
  <slotcom-button
    class="c-button--pink retry-button"
    (click)="reload()">
    {{ 'home.buttons.retry' | translate | uppercase }}
  </slotcom-button>
}
<slotcom-zendesk-button [state]="ZendeskOrigin.Loading"> </slotcom-zendesk-button>
<div class="preloadFonts">
  <span class="signika-light"></span>
  <span class="signika-semibold"></span>
  <span class="signika-bold"></span>
  <span class="museosans900"></span>
  <span class="museosans1000"></span>
  <span class="ubuntu"></span>
  <span class="ubuntu-medium"></span>
  <span class="ubuntu-bold"></span>
  <span class="passion-one"></span>
  <span class="passion-one-bold"></span>
</div>
